import React from "react";
import {TitleCustom} from "../../components/TitleCustom/TitleCustom";
import iconComputerGray from "../../assets/images/icon-computer-gray.svg";
import Margin from "canvas-core-react/lib/Margin";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextBody from "canvas-core-react/lib/TextBody";
import TextCaption from "canvas-core-react/lib/TextCaption";
import {LoadingIframe} from "./biometric/LoadingIframe";
import {PrimaryButtonCustom} from "../../components/PrimaryButtonCustom/PrimaryButtonCustom";

export const LoadingScan = ({validationSuccess, nextStep}) => {
    return (
        <div>
            <TitleCustom
                image={<img src={iconComputerGray} alt="loading scan"/>}
                text="Estamos validando con todas las medidas de seguridad"
            />
            <Margin id="infoBiometric" xs={[18, 0, 48, 0]}>
                <Row className="align-items--center">
                    <Column>
                        <TextBody component="p" type="1">
                            En los siguientes pasos, vamos a realizar la validación para
                            comprobar tu identidad y verificar tus datos.
                        </TextBody>
                    </Column>
                </Row>
            </Margin>
            <Margin id="infoBiometric" xs={18}>
                <Row className="align-items--center">
                    <Column>
                        <TextCaption component="p" bold>
                            ¡Genial, ya casi terminamos!
                        </TextCaption>
                        <TextBody component="p" type="1">
                            Estamos realizando tu validación, el tiempo estimado es de 2
                            minutos.
                        </TextBody>
                    </Column>
                    <Column>{!validationSuccess && <LoadingIframe/>}</Column>
                </Row>
            </Margin>
            <Margin id="ButtonsWizard" xs={60}>
                <Row className="align-items--left">
                    <Column lg={12} xs={4}>
                        <Margin xs={[0, 0, 0, 0]}>
                            <PrimaryButtonCustom
                                id='navigation-continuar-button'
                                disabled={!validationSuccess}
                                onClick={() => nextStep()}
                                text="Continuar"
                            />
                        </Margin>
                    </Column>
                </Row>
            </Margin>
        </div>
    );
};
